import { useProjectActions, useProjectContext } from "@contexts/projects";
import { useEffect, useState } from "react";
import Select, { components } from 'react-select';
import { isPresentationProject } from "@utils/presentationMode";

const Item = ({ index, resource, readOnly }) => {
  const { activeProject, companies } = useProjectContext();
  const { updateLessons } = useProjectActions()
  const currentCompany = companies?.filter(i => i._id === activeProject?.company_id)[0]


  const handleDelete = async (id) => {
    await updateLessons(resource.wbs_code_id, '', id, resource.item_name, 'true')
  }

  return <div key={index} className={`accordion-item offcanvas-accordion-item curve margin-bottom-8 grid columns-6 align-center`}>
    <div className="data">
      <span className="accordion-label">{resource.item_wbs}</span>
      <span className="value">{resource.item_name}</span>
    </div>
    <div className="data column-span-2">
      <span className="accordion-label">Lição</span>
      <span className="value">{resource.lesson}</span>
    </div>
    <div className="data column-span-2">
      <span className="accordion-label">Tags</span>
      <div className="flex flex-wrap">
        {resource.tags?.map((tag, idx) => (
          <p key={idx} style={{ backgroundColor: currentCompany.tags.filter(i => i.name === tag)[0].color, padding: '4px 8px', borderRadius: '32px', fontWeight: 'bold', color: 'whitesmoke' }} className="tag margin-right-4">{tag}</p>
        ))}
      </div>
    </div>
    {!readOnly && <button className="button button-error small" onClick={() => handleDelete(resource._id)}>Deletar</button>}
  </div>
}

const DashLessons = () => {
  const { getLessons } = useProjectActions();
  const { activeProject, companies } = useProjectContext();
  const [resources, setResources] = useState([]);
  const [tagsFilter, setTagsFilter] = useState([])

  const currentCompany = companies?.filter(i => i._id === activeProject?.company_id)[0]
  const readOnly = isPresentationProject(activeProject)

  const getItens = async () => {
    const response = await getLessons();
    if (response?.response) {
      setResources(response.response);
    }
  };

  useEffect(() => {
    if (activeProject) getItens();
  }, [activeProject])

  const handleTags = (e) => {
    setTagsFilter(e.map(i => i.value))
  }

  return (
    <>
      <div style={{ justifyContent: 'end' }} className="flex margin-bottom-24 ">
        <div style={{ width: '300px' }}>
          <Select
            isMulti
            isClearable={false}
            value={tagsFilter.map(i => ({ value: i, label: i }))}
            name="tags"
            options={currentCompany?.tags?.map(i => ({ value: i.name, label: i.name }))}
            onChange={handleTags}
            className="basic-multi-select full-width"
            classNamePrefix="select"
            placeholder='Filtrar por tags'
          />
        </div>

      </div>

      {resources
        ?.filter(resource => tagsFilter.length > 0 ? resource.tags?.some(tag => tagsFilter.includes(tag)) : resource)
        .map((resource) => (
          <Item key={resource._id} index={resource._id} resource={resource} readOnly={readOnly} />
        ))}
    </>
  );
};

export default DashLessons;
